<template>
  <simple-edit-base
    ref="simpleEditBase"
    v-bind="$data"
    :licenses-tooltip="totalLimitDesc"
    @field-change="handleFieldChange"
  >
    <template #header-description>
      <p class="opc-simple-header__description-text">
        <span>{{ configDescription }}</span>
        <participants-diff-popover :type="planType" :color="'var(--zoom-color-text-neutral, #686F79)'" />
      </p>
    </template>

    <template #footer>
      <p v-if="addMoreVisible" class="opc-simple-edit-base__footer-text">
        <span>{{ $t("billing.simple_edit.want_additional_plan_tip", { planName: title }) }}&nbsp;</span>
        <zm-button
          type="link"
          @click="handleAddPlan"
        >
          {{ $t("billing.simple_edit.add_plan") }}
        </zm-button>
      </p>
    </template>
  </simple-edit-base>
</template>
<script>
import SimpleEditBase from "@/components/simple-edit/base.vue";
import planCommon from "@/plans/LARGE_MEETING/mixin";
import ParticipantsDiffPopover from "@/plans/LARGE_MEETING/component/participants-diff-popover.vue";
import { mapGetters } from "vuex";
import { jumpToTargetPageForDiffType } from "@/utils/modal-utils";
import { getPlanTotalLicense } from "@/common/service/validate";

export default {
  name: "LargeMeetingEditSimple",
  components: { ParticipantsDiffPopover, SimpleEditBase },
  mixins: [planCommon],
  data() {
    return {
      showCapacity: true,
      mounted: false,
      licensesMax: 999,
    };
  },
  computed: {
    ...mapGetters(["currentEditPlan", "isDisableAdd2Cart", "basicConfig"]),
    isBulkLicenseAccount() {
      return this.basicConfig?.isBulkLicenseAccount;
    },
    addMoreVisible() {
      if (!this.mounted) {
        return false;
      }
      return !this.isDisableAdd2Cart && this.$refs.simpleEditBase.selectableCapacities.length > 1 && !this.isBulkLicenseAccount;
    },
    addFlowLink() {
      if (!this.mounted) {
        return "";
      }
      const simpleEditBase = this.$refs.simpleEditBase;
      const basePlan = simpleEditBase.currentBasePlans[0] || {};
      const basePlanCount = getPlanTotalLicense(simpleEditBase.currentBasePlans || []);
      return `/opc/buy/add?plan=${basePlan?.category}&subPlan=newsubs&from_sub=large&type=add&majorPlanHost=${basePlanCount}`;
    },
  },
  methods: {
    handleAddPlan() {
      jumpToTargetPageForDiffType(this.addFlowLink);
    },
    handleFieldChange() {
    },
  },
  mounted() {
    this.mounted = true;
  },
};
</script>

<style lang="scss" scoped>
.opc-simple-edit-base {
  &__footer-text {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.15px;
    margin-top: 16px;
  }
}

.opc-simple-header__description-text {
  line-height: 1.5;
  font-size: 14px;
}
</style>
